import ReactSelect, { GroupBase, Props } from 'react-select';
import { twMerge } from 'tailwind-merge';

function Select<
    Option,
    IsMulti extends boolean = false,
    Group extends GroupBase<Option> = GroupBase<Option>
>(props: Props<Option, IsMulti, Group>) {
    const { className, ...reactSelectProps } = props;

    return (
        <ReactSelect
            {...reactSelectProps}
            classNames={{
                control: props =>
                    twMerge(
                        'transition-[outline-color] duration-200',
                        props.isFocused && 'outline outline-1 outline-orange-500 border-neutral-300'
                    )
            }}
            styles={{
                valueContainer: (baseStyles, state) => ({
                    ...baseStyles,
                    paddingTop: 0,
                    paddingBottom: 0
                }),
                control: (baseStyles, state) => ({
                    ...baseStyles,
                    fontSize: '14px',
                    minHeight: '32px',
                    maxHeight: '32px',
                    boxShadow: 'none',
                    outline: 0
                }),
                placeholder: (baseStyles, state) => ({
                    ...baseStyles,
                    fontSize: '14px'
                }),
                dropdownIndicator: (baseStyles, state) => ({
                    ...baseStyles,
                    paddingTop: 0,
                    paddingBottom: 0
                })
            }}
            className={twMerge('w-full', className)}
        />
    );
}

export default Select;
